export default "__VITE_ASSET__DWKUhgX$__"